/* This file is autogenerated, see readme.md for instructions */
import CustomRowSvgIcon from '@bloomreach/banana-theme/icons/custom-row.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CustomRowIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CustomRowSvgIcon />
    </Icon>
  );
});

CustomRowIcon.displayName = 'CustomRowIcon';

export default CustomRowIcon;
